var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFollowSymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0019 75.0024C31.9047 81.9052 43.0956 81.9065 50 75.0061C56.9044 81.9065 68.0952 81.9052 74.9981 75.0024C81.9021 68.0982 81.9021 56.9045 74.9981 50.0004C81.9021 43.0962 81.9021 31.9025 74.9981 24.9983C68.0952 18.0955 56.9044 18.0942 50 24.9946C43.0956 18.0942 31.9048 18.0955 25.0019 24.9983C18.0979 31.9024 18.0979 43.0962 25.0019 50.0003C18.0979 56.9045 18.0979 68.0982 25.0019 75.0024Z",
    fill: "#E2E2E2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.786,
    cy: 11.786,
    r: 11.786,
    transform: "matrix(0.707103 0.707111 -0.707103 0.707111 50 33.3301)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowSymbol);
export default __webpack_public_path__ + "static/media/follow_symbol.e90ca9d5dd4e661fcb1deb7f26b696ce.svg";
export { ForwardRef as ReactComponent };